const forms = {
  state: {
    risk: null,
    riskDID: null,
    riskRegister: null,
    riskRegisterCounter: null,
    riskAssessmentList: null,
    riskAssessmentListCounter: null,
    riskAssessmentListRiskCounter: null,
    riskAnalysisList: null,
    riskAnalysisListCounter: null
  },
  mutations: {
    changeRiskRegister(state, payload) {
      state.riskRegister = payload;
    },
    changeRiskRegisterCounter(state, payload) {
      state.riskRegisterCounter = payload;
    },
    changeRisk(state, payload) {
      state.risk = payload;
    },
    changeRiskDID(state, payload) {
      state.riskDID = payload;
    },
    changeRiskAnalysisList(state, payload) {
      state.riskAnalysisList = payload;
    },
    changeRiskAnalysisListCounter(state, payload) {
      state.riskAnalysisListCounter = payload;
    },
    changeRiskAssessmentList(state, payload) {
      state.riskAssessmentList = payload;
    },
    changeRiskAssessmentListCounter(state, payload) {
      state.riskAssessmentListCounter = payload;
    },
    changeRiskAssessmentListRiskCounter(state, payload) {
      state.riskAssessmentListRiskCounter = payload;
    }
  },
  actions: {
    changeRiskRegister({ commit }, payload) {
      commit("changeRiskRegister", payload);
    },
    changeRiskRegisterCounter({ commit }, payload) {
      commit("changeRiskRegisterCounter", payload);
    },
    changeRisk({ commit }, payload) {
      // commit to store
      commit("changerisk", payload);
    },
    changeRiskDID({ commit }, payload) {
      // commit to store
      commit("changeriskDID", payload);
    },
    changeRiskAnalysisList({ commit }, payload) {
      commit("changeRiskAnalysisList", payload);
    },
    changeRiskAnalysisListCounter({ commit }, payload) {
      commit("changeRiskAnalysisListCounter", payload);
    },
    changeRiskAssessmentList({ commit }, payload) {
      commit("changeRiskAssessmentList", payload);
    },
    changeRiskAssessmentListCounter({ commit }, payload) {
      commit("changeRiskAssessmentListCounter", payload);
    },
    changeRiskAssessmentListRiskCounter({ commit }, payload) {
      commit("changeRiskAssessmentListRiskCounter", payload);
    }
  },
  getters: {
    getRiskRegister: state => {
      return state.riskRegister;
    },
    getRiskRegisterCounter: state => {
      return state.riskRegisterCounter;
    },
    getRisk: state => {
      return state.risk;
    },
    getRiskDID: state => {
      return state.riskDID;
    },
    getRiskAnalysisList: state => {
      return state.riskAnalysisList;
    },
    getRiskAnalysisListCounter: state => {
      return state.riskAnalysisListCounter;
    },
    getRiskAssessmentList: state => {
      return state.riskAssessmentList;
    },
    getRiskAssessmentListCounter: state => {
      return state.riskAssessmentListCounter;
    },
    getRiskAssessmentListRiskCounter: state => {
      return state.riskAssessmentListRiskCounter;
    }
  }
};
// eslint-disable-next-line
export default forms;
